module.exports = __webpack_public_path__ + "static/media/IIe.1b7b3559.jpg";